import { alpha, ClickAwayListener, MenuItem, MenuList, Popover } from '@mui/material';
import React from 'react';
import { H } from '../../Layout';
import { useStyling } from '../../Theme';
import type { ShareOption } from './ShareInfo';
import { ShareOptionDisplay } from './ShareOptionDisplay';

type ShareOptionsMenuProps = {
    open: boolean;
    anchorEl: HTMLElement | null;
    options: ShareOption[];
    selectedValue: boolean;
    isMobile: boolean;
    popoverMinWidth: number;
    onClose: (event?: Event) => void;
    onOptionClick: (value: boolean) => void;
};

export function ShareOptionsMenu({
    open,
    anchorEl,
    options,
    selectedValue,
    isMobile,
    popoverMinWidth,
    onClose,
    onOptionClick
}: ShareOptionsMenuProps) {
    const { theme } = useStyling();

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            slotProps={{
                paper: {
                    sx: {
                        mt: 0.5,
                        minWidth: popoverMinWidth,
                        maxWidth: isMobile ? '90vw' : 'none'
                    }
                }
            }}
        >
            <ClickAwayListener onClickAway={onClose}>
                <MenuList>
                    {options.map((option) => (
                        <MenuItem
                            key={String(option.value)}
                            onClick={() => onOptionClick(option.value)}
                            selected={option.value === selectedValue}
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: alpha(theme.palette.primary.main, 0.06)
                                }
                            }}
                        >
                            <H gap={1} sx={{ alignItems: 'center', width: '100%' }}>
                                <ShareOptionDisplay option={option} />
                            </H>
                        </MenuItem>
                    ))}
                </MenuList>
            </ClickAwayListener>
        </Popover>
    );
}
